'use strict';

angular.module('userRequestEditControllers')

.directive('networkShare', [function () {
    return {
        scope: {
            systemRole: '=',
            accessRequest: '=',
            removeWhenNotPending: '@',
            afterChanges: '&',
            layoutRatio: '&'
        },
        templateUrl: require('./NetworkShare.tpl.html'),
        controller: ['$scope', '$state', 'editAccessRequestService', function ($scope, $state, editAccessRequestService) {

            var editService = editAccessRequestService.systemRolePendings;

            // Is Existing
            $scope.isExisting = !_.isUndefined(_.find($scope.accessRequest.existings, { SystemRoleID: $scope.systemRole.SystemRoleID }));

            // Actions Pre ADD
            $scope.preAdd = function () {
                editService.preAdd($scope.accessRequest.UserAccessRequestID, $scope.systemRole.SystemRoleID)
                .then(function (updatedSystemRole) {
                    if (!_.isUndefined(updatedSystemRole.GrowlMessages)) return;

                    $scope.systemRole.ToKeep = undefined;
                    $scope.systemRole.ToAdd = true;

                    if (!_.isUndefined($scope.afterChanges)) {
                        $scope.afterChanges();
                    }
                });
            }

            // Actions Pre CLOSE
            $scope.preClose = function () {
                editService.preClose($scope.accessRequest.UserAccessRequestID, $scope.systemRole.SystemRoleID)
                .then(function (updatedSystemRole) {
                    if (!_.isUndefined(updatedSystemRole.GrowlMessages)) return;

                    $scope.systemRole.ToKeep = undefined;
                    $scope.systemRole.ToAdd = false;
                    $scope.systemRole.ToRemove = true;

                    if (!_.isUndefined($scope.afterChanges)) {
                        $scope.afterChanges();
                    }
                });
            }

            // Actions DELETE
            $scope.delete = function () {
                editService.delete($scope.accessRequest.UserAccessRequestID, $scope.systemRole.SystemRoleID)
                .then(function (updatedSystemRole) {
                    if (!_.isUndefined(updatedSystemRole.GrowlMessages)) return;

                    $scope.systemRole.ToKeep = undefined;
                    $scope.systemRole.ToAdd = undefined;
                    $scope.systemRole.ToRemove = undefined;

                    if ($scope.removeWhenNotPending === 'true') {
                        $scope.systemRole.toDisplay = false;
                    }

                    if (!_.isUndefined($scope.afterChanges)) {
                        $scope.afterChanges();
                    }
                });
            }

            // Actions KEEP
            $scope.keep = function () {
                editService.keep($scope.accessRequest.UserAccessRequestID, $scope.systemRole.SystemRoleID)
                .then(function (updatedSystemRole) {
                    if (!_.isUndefined(updatedSystemRole.GrowlMessages)) return;

                    $scope.systemRole.ToKeep = true;

                    if (!_.isUndefined($scope.afterChanges)) {
                        $scope.afterChanges();
                    }
                });
            }

            // Actions REVERT KEEP
            $scope.revertKeep = function (systemRole) {
                editService.revertKeep($scope.accessRequest.UserAccessRequestID, $scope.systemRole.SystemRoleID)
                .then(function (updatedSystemRole) {
                    if (!_.isUndefined(updatedSystemRole.GrowlMessages)) return;

                    $scope.systemRole.ToKeep = undefined;

                    if (!_.isUndefined($scope.afterChanges)) {
                        $scope.afterChanges();
                    }
                });
            }

            // Label
            $scope.label = function () {
                var roleName = $scope.systemRole.SystemRoleName.toUpperCase();
                if (roleName === 'MODIFY') return 'label label-blue';
                return 'label label-gray';
            }
        }],
        link: function (scope, element, attrs) {

            scope.layoutRatio = attrs.layoutRatio ? scope.$eval(attrs.layoutRatio) : {
                systemRoleColumn: 'col-md-2',
                systemColumn: 'col-md-10'
            };
        }
    };
}]);